import { ITradslagsFilter } from "./ITradslagsFilter";

export class TradslagsFilter implements ITradslagsFilter {
    tall: number;
    gran: number;
    lov: number;
    contorta: number;

    constructor() {
        this.tall = null;
        this.gran = null;
        this.lov = null;
        this.contorta = null;
    }

}
